import { login as f, getConversationHistory as E, deleteUser as y, getUser as M, createFile as R, deleteMessage as U, getMessage as b, updateConversation as T, createMessage as $, listConversationMessages as S, listConversations as _, deleteConversation as x, getConversation as A, createConversation as I } from "./hitl-client3.js";
import { client as p } from "./hitl-client4.js";
import { EventSource as N } from "./hitl-client5.js";
import { createEventEmitter as k } from "./hitl-client6.js";
const n = (o) => o.data, u = {
  throwOnError: !0
}, O = ({
  webhookId: o,
  accessToken: g,
  apiUrl: d
}) => {
  const t = `${d || p.getConfig().baseUrl}/${o}`, c = {
    ...u,
    baseUrl: t
  };
  return f({ ...c, headers: { "x-access-token": g }, body: {} }).then(n);
}, V = ({
  userKey: o,
  webhookId: g,
  apiUrl: d
}) => {
  const t = {
    "x-user-key": o
  }, c = `${d || p.getConfig().baseUrl}/${g}`, s = {
    ...u,
    baseUrl: c
  };
  return {
    createConversation: () => I({ ...s, headers: t, body: {} }).then(n),
    getConversation: ({ conversationId: e }) => A({ ...s, headers: t, path: { id: e } }).then(n),
    deleteConversation: ({ conversationId: e }) => x({ ...s, headers: t, path: { id: e } }).then(n),
    listConversations: ({ nextToken: e }) => _({ ...s, headers: t, query: { nextToken: e } }).then(n),
    listConversationMessages: ({ conversationId: e, nextToken: h }) => S({
      ...s,
      headers: t,
      path: { id: e },
      query: { nextToken: h }
    }).then(n),
    createMessage: (e) => $({ ...s, headers: t, body: e }).then(n),
    updateConversation: ({ conversationId: e, ...h }) => T({ ...s, headers: t, body: h, path: { id: e } }).then(n),
    getMessage: ({ messageId: e }) => b({ ...s, headers: t, path: { id: e } }).then(n),
    deleteMessage: ({ messageId: e }) => U({ ...s, headers: t, path: { id: e } }).then(n),
    createFile: (e) => R({ ...s, headers: t, body: e }).then(n),
    getUser: () => M({ ...s, headers: t }).then(n),
    deleteUser: () => y({ ...s, headers: t }).then(n),
    getConversationHistory: ({ conversationId: e }) => E({ ...s, headers: t, path: { id: e } }).then(n),
    listenConversation: ({ conversationId: e }) => {
      let v = 0, a = null;
      const l = k(), C = () => {
        a && a.close();
        const m = `${c}/conversations/${e}/listen`;
        a = new N(m, {
          fetch: (i, r) => fetch(i, {
            ...r,
            headers: {
              ...r == null ? void 0 : r.headers,
              ...t,
              timeout: "60_000"
            }
          })
        }), a.onopen = () => l.emit("open"), a.onerror = (i) => {
          l.emit("error", i), v < 10 && (v++, setTimeout(() => C(), 3e3));
        }, a.onmessage = (i) => {
          const r = q(i.data);
          l.emit(r.type, r.data);
        };
      };
      return C(), l.on;
    }
  };
}, q = (o) => {
  try {
    return JSON.parse(o);
  } catch {
    return o;
  }
};
export {
  V as createClient,
  O as login
};
